import React from 'react';
import './HomeItemCss.css';
import styled from 'styled-components';
import {Col} from "react-bootstrap";
import {DateDisplay} from "../Extra/DateDisplay";
import {useNavigate} from "react-router-dom";
import { UrlFixer } from '../../utils/utils';

const ArticleCol = styled(Col)`
    margin-bottom: 25px;
`;

const ArticleBox = styled.div`
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0px 2px 10px #aaa;
    cursor: pointer;
    height: 100%;
    position: relative;
`

const ArticleThumb = styled.div`
    position: relative;
    overflow: hidden;
    & img {
        width: 100%;
    }
`;



const StyledArticleItemTitle = styled.div`
    margin: 5px;
    position: relative;
    height: 100%;
    padding: 1rem;
    min-height: 18rem;
    & h5 a {
        color: #222;
        text-decoration: none;
        font-family: 'Roboto Slab', sans-serif;
        font-weight: bold;
        font-size: 24px;
    }
    & h5 a:hover {
        color: green;
    }
    & p {
        font-family: 'Poppins',sans-serif;
        font-weight: 400;
        margin-bottom: 5rem;
        text-decoration: none;
    }
    & ul.post-meta li {
        display: inline-flex;
        font-size: 0.9rem;
    }
    & ul.post-meta li span {
        color: #689f38;
    }
`;

const StyledArticleEndCap = styled.div`
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    text-align: center;
    color: #fff;
    font-weight: bold;
    background: rgba(104, 159, 56, 1);
    padding-top: 15px;
    padding-bottom: 15px;
    text-transform: uppercase;
    margin-top: auto;
    position: absolute;
    bottom: 0;
    width: 100%;
    cursor: pointer;
`;

export const HomeArticleItem = (props) => {

    const article = props.article;

    const navigate = useNavigate();

    function clickHandler(id, slug, e) {
        e.preventDefault();
        e.stopPropagation();
        let url = 'articles/'+id+'/' + slug;
        navigate(url);
    }

    return (
        <ArticleCol xs={12} md={4}>
            <ArticleBox onClick={(e) => clickHandler(article.id, article.slug, e)}>
            <ArticleThumb>  
                <img src={UrlFixer(article.image_details.variations.home_list_item_small)} alt={article.title} />
            </ArticleThumb>
                <StyledArticleItemTitle>
                    <h5><a href={"/articles/"+article.id+"/"+article.slug}>{article.title}</a></h5>
                    <ul className="post-meta">
                        <li><span>Posted:</span><DateDisplay datetime={article.published_at} /></li>
                    </ul>
                    <p> {article.intro}</p>
                </StyledArticleItemTitle>
                <StyledArticleEndCap>
                    read more
                </StyledArticleEndCap>
            </ArticleBox>
        </ArticleCol>
    )
}